module.exports = __webpack_public_path__ + "img/yhnc.6d2995b8.png";